import { render, staticRenderFns } from "./CustomFieldItemForm.vue?vue&type=template&id=1dbf1298"
import script from "./CustomFieldItemForm.vue?vue&type=script&lang=js"
export * from "./CustomFieldItemForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports